/* eslint-disable @typescript-eslint/no-explicit-any */
export enum AnalyticsUserFlow {
  APPOINTMENTS = "appointments", // named 'All visits' in spreadsheet
  APPOINTMENT_DETAILS = "appointment_detail",
  APP_UPDATE = "app_update",
  APP_REVIEW = "app_review",
  BILLS_AND_PAYMENTS = "bills_and_payments",
  FIND_CITYMD = "find_citymd",
  GET_VIRTUAL_URGENT_CARE = "get_virtual_urgent_care",
  HOME = "home", // dashboard
  LOCATION = "location",
  MESSAGES = "messages",
  ONBOARDING_NEW = "onboarding_new",
  ONBOARDING_OLD = "onboarding_old",
  MY_ACCOUNT = "my_account", // account settings
  MY_HEALTH = "my_health",
  RESULTS = "results",
  SCHEDULE_VISIT = "schedule_visit",
  PROVIDER_SEARCH = "provider_search",
}
